import React from 'react';
import './styles.scss';

const ProgressBar = ({completedCount, totalCount, currentLabel}) => {
	const percentage = totalCount
		? Math.min((completedCount / totalCount) * 100, 100)
		: 0;

	return (
		<div className="screening-progress">
			<div className="screening-progress__top">
				<span className="screening-progress__label">
					Teiltest {completedCount} von {totalCount}
					{currentLabel ? `: ${currentLabel}` : ''}
				</span>
				<span className="screening-progress__percent">
					{Math.round(percentage)}%
				</span>
			</div>

			<div className="screening-progress__bar">
				<div
					className="screening-progress__fill"
					style={{width: `${percentage}%`}}
				/>
			</div>
		</div>
	);
};

export default ProgressBar;